import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "scroll-container" }
const _hoisted_2 = { class: "scroll-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_GenericTabs = _resolveComponent("GenericTabs")!
  const _component_CharacterLoad = _resolveComponent("CharacterLoad")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "char-stats-container",
    title: "CHARACTER LIBRARY"
  }, {
    "icons-right": _withCtx(() => [
      _createVNode(_component_GenericButton, {
        svg: "close",
        onClick: _ctx.closePanel
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_GenericTabs, {
        tabs: _ctx.tabs,
        variant: "contained",
        "max-width": "60%",
        onActiveTab: _ctx.handleActiveTab
      }, null, 8, ["tabs", "onActiveTab"]),
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.characters, (char) => {
          return (_openBlock(), _createBlock(_component_CharacterLoad, {
            key: char.name,
            char: char
          }, null, 8, ["char"]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.selectedTab === 'SAVED']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presets, (char) => {
          return (_openBlock(), _createBlock(_component_CharacterLoad, {
            key: char.name,
            char: char,
            preset: ""
          }, null, 8, ["char"]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.selectedTab === 'PRESETS']
      ])
    ]),
    _: 1
  }))
}